/**
 * The attribute that marks engine-authored facts in rendered HTML.
 *
 * WHY IT EXISTS. The earn contract (rule 66) requires `engine_or_experience_proof`,
 * but `page_quality_gate.py::proof_check` only verifies that a route's registry
 * entry DECLARES a `quality_proof.source_symbol` and that the symbol is called in
 * the route's source. Nothing checked that the engine's values reached the served
 * HTML — which is how 562 programmatic pages across 13 families satisfied the
 * contract on paper while rendering zero engine-computed values.
 * `execution/indexable_value_rules.py::count_engine_facts` counts this marker so
 * the live gate can assert presence instead of trusting a declaration.
 *
 * WHY IT IS SINGLE-SOURCED. Two renderers used to emit it, for two populations:
 * the content Worker's D1 engine-fact block (deleted with that renderer on
 * 2026-11-03) and `src/components/ReferenceTable.tsx` with the other Next
 * routes, which can render nothing but an engine-generated `ReferenceDataset`.
 *
 * Both were written independently and happened to choose the same string. That
 * coincidence is not a contract: a rename in either renderer would silently take
 * the count to zero on its population, and NOTHING would fail — a fail-open gate
 * is worse than no gate (rules 23/24, the "drifting copies" class). Hence one
 * constant, imported by every renderer, pinned across the TS/Python boundary by
 * `tests/test_engine_fact_marker_parity.py`.
 *
 * WHAT MAY EMIT IT. Only a renderer whose values come from the engine — never
 * model-drafted prose. A proof a page can talk its way into is not a proof.
 */
export const ENGINE_FACT_MARKER = "data-engine-facts";
